// Imports
import firebase from '../config/FirebaseConfig'

// Setup
const db = firebase.firestore()

// Get fb_ads_page_track
const getByPageId = async (pageId) => {
  const snapshot = await db
    .collection('fb_ads_page_track')
    .where('pageId', '==', pageId)
    .limit(1)
    .get()

  const spyderInstance = snapshot.docs[0]

  return {
    ...spyderInstance.data(),
    id: spyderInstance.id
  }
}

// Update fb_ads_page_track
const update = (spyderId, payload) => {
  return db
    .collection('fb_ads_page_track')
    .doc(spyderId)
    .update(payload)
}

// Adds new doc to fb_ads_page_track
const create = (payload) => {
  return db
    .collection('fb_ads_page_track')
    .add(payload)
}

// Check if user is tracking a brand
const checkIsTrackingBrand = async (subscriptionId, brandId) => {
  const snapshot = await db
    .collection('fb_ads_page_track')
    .where('brandId', '==', brandId)
    .get()

  const brandSubscription = snapshot.docs?.[0]?.data()
  if (!brandSubscription) return false

  return brandSubscription.subscribers.includes(subscriptionId)
}

export default {
  create,
  getByPageId,
  update,
  checkIsTrackingBrand
}
